// Default monthly SMS allowance for a given plan price.
//
// This mirrors `monthlySMSQuotaFunction` in
// functions/sales_marketing_function/utils/customHelper.js. It is duplicated
// rather than imported because that module pulls in @sendgrid/mail, axios and
// promaHelper, none of which can be bundled for the browser — and CRA refuses
// relative imports from outside src/ in any case.
//
// KEEP THE TWO IN SYNC: if the plan tiers change on one side, change the other.
export const monthlySMSQuotaFunction = (monthlyFee) => {
  switch (Number(monthlyFee)) {
    case 99:
      return 500;
    case 139:
      return 1000;
    case 169:
      return 2000;
    case 189:
      return 3000;
    case 199:
      return 3000;
    default:
      return Number(monthlyFee) > 199 ? 3000 : undefined;
  }
};
